// src/types.ts
function isRef(check) {
  return check.$ref !== void 0;
}
function isOAS31(check) {
  return check.openapi === "3.1.0";
}
function isSchema(check, isPolymorphicAllOfChild = false) {
  return check.type !== void 0 || check.allOf !== void 0 || check.anyOf !== void 0 || check.oneOf !== void 0 || isPolymorphicAllOfChild;
}

export {
  isRef,
  isOAS31,
  isSchema
};
//# sourceMappingURL=chunk-UCEHCARG.js.map